'use strict';

var React = require('react');

module.exports = function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.4.1@rc-util/lib/Children/toArray.js
 ** module id = 507
 ** module chunks = 0
 **/